import { createContext } from "react";
import type { User, AuthProvider as FirebaseAuthProvider } from "firebase/auth";

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isInitialLoading: boolean;
  isSuperAdmin: boolean; // Whether user has the "super-admin" custom claim
  isSupport: boolean; // Whether user has the "support" custom claim (read-only backend access)
  login: (provider: FirebaseAuthProvider) => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | null>(null);
